<main class="w-full h-full flex justify-center items-center">
	<div class="tree-balls animation-tree-balls loadingColor"></div>
</main>
